import React, { useEffect, useState } from 'react';
import "../Electrician/Electrician.css"
import { useNavigate } from "react-router-dom";
import img1 from "../../assets/images/Laundry/iron-1.png"
import img2 from "../../assets/images/Laundry/Dry_Wash.png"
import img3 from "../../assets/images/Laundry/chemical.png"
import img4 from "../../assets/images/Laundry/starch.png"
import img5 from "../../assets/images/Laundry/stains.png"
const Laundry = ({cart, addToCart}) => {
    const navigate = useNavigate();
      const [openService, setOpenService] = useState(null);
      const services = [
  {
    id: 901,
    title: "One Pair Iron",
    price: 30,
    subtitle: "Quick ironing service for a pair of clothes",
    extra_detail_1: "Neat pressing for shirts, pants, or similar garments",
    extra_detail_2: "Removes wrinkles and gives a crisp finish",
    image: img1
  },
  {
    id: 902,
    title: "Dry Wash",
    price: 80,
    subtitle: "Gentle cleaning without water",
    extra_detail_1: "Suitable for delicate fabrics like silk and wool",
    extra_detail_2: "Removes dirt while maintaining fabric quality",
    image: img2
  },
  {
    id: 903,
    title: "Chemical Wash",
    price: 120,
    subtitle: "Advanced cleaning using chemical solutions",
    extra_detail_1: "Deep cleaning for tough stains and dirt",
    extra_detail_2: "Enhances fabric freshness and longevity",
    image: img3
  },
  {
    id: 904,
    title: "Rolling / Starch",
    price: 90,
    subtitle: "Starching and rolling for crisp finish",
    extra_detail_1: "Provides stiffness and premium look to clothes",
    extra_detail_2: "Ideal for cotton wear like sarees and shirts",
    image: img4
  },
  {
    id: 905,
    title: "Stains Wash",
    price: 160,
    subtitle: "Special treatment for stain removal",
    extra_detail_1: "Targets tough stains like oil, ink, and dirt",
    extra_detail_2: "Careful cleaning to avoid fabric damage",
    image: img5
  },
  {
  id: 906,
  title: "Shirt/Pant/Jeans/T-Shirt/Dhoti Cleaning",
  price: 110,
  subtitle: "Professional cleaning service for garments",
  extra_detail_1: "Deep cleaning for better freshness and hygiene",
  extra_detail_2: "Removes stains, dirt, and odors effectively",
  image: img1
},
{
  id: 907,
  title: "Shirt/Pant/Jeans/T-Shirt/Dhoti Pressing",
  price: 45,
  subtitle: "Professional pressing service for garments",
  extra_detail_1: "Neat ironing with wrinkle-free finish",
  extra_detail_2: "Gives clothes a crisp and polished look",
  image: img1
},
{
  id: 908,
  title: "Pyjama/Capri Cleaning",
  price: 100,
  subtitle: "Professional cleaning service for garments",
  extra_detail_1: "Deep cleaning for better freshness and hygiene",
  extra_detail_2: "Removes stains, dirt, and odors effectively",
  image: img1
},
{
  id: 909,
  title: "Pyjama/Capri Pressing",
  price: 45,
  subtitle: "Professional pressing service for garments",
  extra_detail_1: "Neat ironing with wrinkle-free finish",
  extra_detail_2: "Gives clothes a crisp and polished look",
  image: img1
},
{
  id: 910,
  title: "Achkan/Sherwani Cleaning",
  price: 425,
  subtitle: "Professional cleaning service for garments",
  extra_detail_1: "Deep cleaning for better freshness and hygiene",
  extra_detail_2: "Removes stains, dirt, and odors effectively",
  image: img1
},
{
  id: 911,
  title: "Achkan/Sherwani Pressing",
  price: 165,
  subtitle: "Professional pressing service for garments",
  extra_detail_1: "Neat ironing with wrinkle-free finish",
  extra_detail_2: "Gives clothes a crisp and polished look",
  image: img1
},
{
  id: 912,
  title: "Kurta Cleaning",
  price: 130,
  subtitle: "Professional cleaning service for garments",
  extra_detail_1: "Deep cleaning for better freshness and hygiene",
  extra_detail_2: "Removes stains, dirt, and odors effectively",
  image: img1
},
{
  id: 913,
  title: "Kurta Pressing",
  price: 50,
  subtitle: "Professional pressing service for garments",
  extra_detail_1: "Neat ironing with wrinkle-free finish",
  extra_detail_2: "Gives clothes a crisp and polished look",
  image: img1
},
{
  id: 914,
  title: "Sweat Shirt Cleaning",
  price: 265,
  subtitle: "Professional cleaning service for garments",
  extra_detail_1: "Deep cleaning for better freshness and hygiene",
  extra_detail_2: "Removes stains, dirt, and odors effectively",
  image: img1
},
{
  id: 915,
  title: "Sweat Shirt Pressing",
  price: 110,
  subtitle: "Professional pressing service for garments",
  extra_detail_1: "Neat ironing with wrinkle-free finish",
  extra_detail_2: "Gives clothes a crisp and polished look",
  image: img1
},
{
  id: 916,
  title: "Blazer/Coat Cleaning",
  price: 300,
  subtitle: "Professional cleaning service for garments",
  extra_detail_1: "Deep cleaning for better freshness and hygiene",
  extra_detail_2: "Removes stains, dirt, and odors effectively",
  image: img1
},
{
  id: 917,
  title: "Blazer/Coat Pressing",
  price: 125,
  subtitle: "Professional pressing service for garments",
  extra_detail_1: "Neat ironing with wrinkle-free finish",
  extra_detail_2: "Gives clothes a crisp and polished look",
  image: img1
},
{
  id: 918,
  title: "Jacket Cleaning",
  price: 270,
  subtitle: "Professional cleaning service for garments",
  extra_detail_1: "Deep cleaning for better freshness and hygiene",
  extra_detail_2: "Removes stains, dirt, and odors effectively",
  image: img1
},
{
  id: 919,
  title: "Jacket Pressing",
  price: 110,
  subtitle: "Professional pressing service for garments",
  extra_detail_1: "Neat ironing with wrinkle-free finish",
  extra_detail_2: "Gives clothes a crisp and polished look",
  image: img1
},
{
  id: 920,
  title: "Shirt/Pant/Jeans/T-Shirt Cleaning",
  price: 110,
  subtitle: "Professional cleaning service for garments",
  extra_detail_1: "Deep cleaning for better freshness and hygiene",
  extra_detail_2: "Removes stains, dirt, and odors effectively",
  image: img2
},
{
  id: 921,
  title: "Shirt/Pant/Jeans/T-Shirt Pressing",
  price: 45,
  subtitle: "Professional pressing service for garments",
  extra_detail_1: "Neat ironing with wrinkle-free finish",
  extra_detail_2: "Gives clothes a crisp and polished look",
  image: img2
},
{
  id: 922,
  title: "Shawl Cleaning",
  price: 185,
  subtitle: "Professional cleaning service for garments",
  extra_detail_1: "Deep cleaning for better freshness and hygiene",
  extra_detail_2: "Removes stains, dirt, and odors effectively",
  image: img2
},
{
  id: 923,
  title: "Shawl Pressing",
  price: 80,
  subtitle: "Professional pressing service for garments",
  extra_detail_1: "Neat ironing with wrinkle-free finish",
  extra_detail_2: "Gives clothes a crisp and polished look",
  image: img2
},
{
  id: 924,
  title: "Skirt Cleaning",
  price: 160,
  subtitle: "Professional cleaning service for garments",
  extra_detail_1: "Deep cleaning for better freshness and hygiene",
  extra_detail_2: "Removes stains, dirt, and odors effectively",
  image: img2
},
{
  id: 925,
  title: "Skirt Pressing",
  price: 70,
  subtitle: "Professional pressing service for garments",
  extra_detail_1: "Neat ironing with wrinkle-free finish",
  extra_detail_2: "Gives clothes a crisp and polished look",
  image: img2
},
{
  id: 926,
  title: "Salwar/Capri/Track Pant Cleaning",
  price: 100,
  subtitle: "Professional cleaning service for garments",
  extra_detail_1: "Deep cleaning for better freshness and hygiene",
  extra_detail_2: "Removes stains, dirt, and odors effectively",
  image: img2
},
{
  id: 927,
  title: "Salwar/Capri/Track Pant Pressing",
  price: 45,
  subtitle: "Professional pressing service for garments",
  extra_detail_1: "Neat ironing with wrinkle-free finish",
  extra_detail_2: "Gives clothes a crisp and polished look",
  image: img2
},
{
  id: 928,
  title: "Dress Cleaning",
  price: 225,
  subtitle: "Professional cleaning service for garments",
  extra_detail_1: "Deep cleaning for better freshness and hygiene",
  extra_detail_2: "Removes stains, dirt, and odors effectively",
  image: img2
},
{
  id: 929,
  title: "Dress Pressing",
  price: 90,
  subtitle: "Professional pressing service for garments",
  extra_detail_1: "Neat ironing with wrinkle-free finish",
  extra_detail_2: "Gives clothes a crisp and polished look",
  image: img2
},
{
  id: 930,
  title: "Kurta/Top Cleaning",
  price: 130,
  subtitle: "Professional cleaning service for garments",
  extra_detail_1: "Deep cleaning for better freshness and hygiene",
  extra_detail_2: "Removes stains, dirt, and odors effectively",
  image: img2
},
{
  id: 931,
  title: "Kurta/Top Pressing",
  price: 50,
  subtitle: "Professional pressing service for garments",
  extra_detail_1: "Neat ironing with wrinkle-free finish",
  extra_detail_2: "Gives clothes a crisp and polished look",
  image: img2
},
{
  id: 932,
  title: "Lehnga Cleaning",
  price: 360,
  subtitle: "Professional cleaning service for garments",
  extra_detail_1: "Deep cleaning for better freshness and hygiene",
  extra_detail_2: "Removes stains, dirt, and odors effectively",
  image: img2
},
{
  id: 933,
  title: "Lehnga Pressing",
  price: 145,
  subtitle: "Professional pressing service for garments",
  extra_detail_1: "Neat ironing with wrinkle-free finish",
  extra_detail_2: "Gives clothes a crisp and polished look",
  image: img2
},
{
  id: 934,
  title: "Blazer/Coat Cleaning",
  price: 300,
  subtitle: "Professional cleaning service for garments",
  extra_detail_1: "Deep cleaning for better freshness and hygiene",
  extra_detail_2: "Removes stains, dirt, and odors effectively",
  image: img2
},
{
  id: 935,
  title: "Blazer/Coat Pressing",
  price: 125,
  subtitle: "Professional pressing service for garments",
  extra_detail_1: "Neat ironing with wrinkle-free finish",
  extra_detail_2: "Gives clothes a crisp and polished look",
  image: img2
},
{
  id: 936,
  title: "Pyjama/Plazo/Stocking/Legging/Slacks Cleaning",
  price: 100,
  subtitle: "Professional cleaning service for garments",
  extra_detail_1: "Deep cleaning for better freshness and hygiene",
  extra_detail_2: "Removes stains, dirt, and odors effectively",
  image: img2
},
{
  id: 937,
  title: "Pyjama/Plazo/Stocking/Legging/Slacks Pressing",
  price: 45,
  subtitle: "Professional pressing service for garments",
  extra_detail_1: "Neat ironing with wrinkle-free finish",
  extra_detail_2: "Gives clothes a crisp and polished look",
  image: img2
},
{
  id: 938,
  title: "Blouse Cleaning",
  price: 80,
  subtitle: "Professional cleaning service for garments",
  extra_detail_1: "Deep cleaning for better freshness and hygiene",
  extra_detail_2: "Removes stains, dirt, and odors effectively",
  image: img2
},
{
  id: 939,
  title: "Blouse Pressing",
  price: 35,
  subtitle: "Professional pressing service for garments",
  extra_detail_1: "Neat ironing with wrinkle-free finish",
  extra_detail_2: "Gives clothes a crisp and polished look",
  image: img2
}

      ];
  return (
    <div className='container-fluid service-electrician'>
      <div id="Electronic">
        <h1>Laundry</h1>
      </div>
      <div className='elect-container'>
        <div className="services-section-elect">
          {services.map((service) => {
            const isAdded = cart.some(
              item => item.id === service.id && item.category === service.category
            );
            return (
              <div key={service.id} className="service-card-elect">

                <div className="service-details-elect">
                  <h3>{service.title}</h3>

                  <div className="price-section-elect">
                    <span className="new-price-elect">₹{service.price}</span>
                  </div>
                  <button
                    className=" btn btn-link view-details-elect"
                    onClick={() =>
                      setOpenService(openService === service.id ? null : service.id)
                    }
                  >
                    View Details
                  </button>
                  {openService === service.id && (
                    <div className="extra-details-elect">
                      <p>✔ {service.extra_detail_1}</p>
                      <p>✔ {service.extra_detail_2}</p>
                    </div>
                  )}

                  <ul>
                    <li>{service.subtitle}</li>
                  </ul>
                </div>

                <div className="service-image-elect">
                  <img src={service.image} alt="" /><br />
                  <button
                    onClick={() => addToCart(service)}
                    className={`btn px-5 mt-2 ${isAdded ? "btn-success" : "btn-warning"
                      }`}
                  >
                    {isAdded ? "Added" : "Add"}
                  </button>
                </div>

              </div>
            );
          })}
        </div>
      </div>
    </div>
  )
}

export default Laundry
